import { Button } from "./Button";

export class SharedTurnsButton extends Button {
  // eslint-disable-next-line @typescript-eslint/class-methods-use-this, @typescript-eslint/no-empty-function
  setLeft: (this: SharedTurnsButton) => void = () => {};

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this, @typescript-eslint/no-empty-function
  setCenter: (this: SharedTurnsButton) => void = () => {};
}
